export default __webpack_public_path__ + "images/huurauto-sleutels477e6deef22424fb7fa79750c5b7deb1.svg";